<template>
  <b-row class="g-2">
    <b-col v-for="item in landingBars" :key="`bars-${item.id}`">
      <b-card no-body class="h-100">
        <b-card-body class="text-info-box__body">
          <h2 class="text-info-box__title" v-html="item.label" />
          <div class="text-info-box__text" :class="{'list-style-unset': sid === 'abaooe'}" v-html="item.info_text" @click="handleContentClick"></div>
          <b-img-lazy v-if="item.picture" :src="pictureUrl(item.picture)" alt="" class="img-fluid d-block w-100 h-auto" />
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { AppModule, SettingsLandingBar } from '@/store/modules/app';
import { SERVER_URL } from '@/config/constant';
import { routeInternalContentLink } from '@/helpers/contentLinks';
import { Component, Vue } from 'vue-property-decorator';

const PICTURE_PATH = '/jobnet/partner_admin/jobnews_admin/get_image';

@Component
export default class TextInformationBox extends Vue {
  get landingBars(): SettingsLandingBar[] {
    return AppModule.settingPortal.landing_bars;
  }

  get sid() {
    return AppModule.sid;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  handleContentClick(event: MouseEvent) {
    routeInternalContentLink(event, this.$router);
  }

  // На відміну від clusters/info_bars, у landing_bars бек віддає лише ім'я файлу.
  pictureUrl(picture: string) {
    return `${SERVER_URL}${PICTURE_PATH}?portal=1&sid=${this.languageSid}&file=${encodeURIComponent(picture)}`;
  }
}
</script>
<style lang="scss" scoped>
  .list-style-unset ::v-deep li {
    list-style: unset;
  }

  .text-info-box__body {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.25rem;
  }

  .text-info-box__title {
    margin: 0 0 .75rem;
    color: #0054A6;
    font-family: Roboto, Arial, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
  }

  .text-info-box__text {
    color: #333333;
    font-family: Roboto, Arial, sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.6;

    ::v-deep p {
      margin: 0;

      & + p {
        margin-top: .75rem;
      }
    }
  }
</style>
